import { useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { useUsersStore } from '@/stores/users';
import { ERouterNames, EUserRoles } from '@/types';

type Props = {
  roles: EUserRoles[];
};

export const AccessControlLayout = ({ roles }: Props) => {
  const navigate = useNavigate();
  const { allRoles } = useUsersStore((state) => ({
    allRoles: state.getAllRoles(),
  }));

  useEffect(() => {
    const check = roles.some((item) => {
      return allRoles.includes(item);
    });
    if (!check) {
      navigate(ERouterNames.ROUTE_ME);
    }
  }, [allRoles, navigate, roles]);

  return <Outlet />;
};
